import { FC, PropsWithChildren, ReactNode } from 'react'

import { DetailsCell, DetailsCellSkeleton, Group, HStack } from '@revolut-internal/ui-kit'

type ResourcesPanelSectionProps = PropsWithChildren<{
  title?: string
  action?: ReactNode
  side?: ReactNode
  isPending?: boolean
  isEmpty?: boolean
}>

export const ResourcesPanelSection: FC<ResourcesPanelSectionProps> = ({
  title,
  side,
  action,
  isPending = false,
  isEmpty = false,
  children,
}) => {
  if (isPending) {
    return (
      <Group>
        <DetailsCellSkeleton>
          <DetailsCellSkeleton.Title />
          {side && <DetailsCellSkeleton.Content />}
        </DetailsCellSkeleton>

        {children}
      </Group>
    )
  }

  return (
    <Group>
      {!isEmpty && (
        <DetailsCell pt="s-16" pb="s-8">
          <DetailsCell.Title>
            <HStack space="s-8" align="center">
              {title}
              {action}
            </HStack>
          </DetailsCell.Title>
          {side && <DetailsCell.Content>{side}</DetailsCell.Content>}
        </DetailsCell>
      )}

      {children}
    </Group>
  )
}
